<template>
  <div class="container" style="width: 100%;">
    <!-- Item Add Section -->
    <div class="row align-items-center mb-3 w-100 m-0">
      <!-- Item Dropdown -->
      <div class="col-md-3">
        <label>Select Item</label>
        <select class="form-control" v-model="selectedItem">
          <option value="" disabled>Select Item</option>
          <option v-for="item in availableItems"
                  :key="item.id"
                  :value="item.id">
            {{ item.item_name }}
          </option>
        </select>
        <div v-if="errors.item" class="text-danger mt-1" style="font-size: 0.85em;">{{ errors.item }}</div>
      </div>

      <!-- Normal Quantity -->
      <div class="col-md-3">
        <label>Normal Qty</label>
        <input
          type="number"
          class="form-control"
          v-model="normalQty"
          placeholder="Enter normal qty"
          min="0"
        />
        <div v-if="errors.normalQty" class="text-danger mt-1" style="font-size: 0.85em;">
          {{ errors.normalQty }}
        </div>
      </div>

      <!-- Damaged Quantity -->
      <div class="col-md-3">
        <label>Damaged Qty</label>
        <input
          type="number"
          class="form-control"
          v-model="damagedQty"
          placeholder="Enter damaged qty"
          min="0"
          @keydown.enter="addItem"
        />
        <div v-if="errors.damagedQty" class="text-danger mt-1" style="font-size: 0.85em;">
          {{ errors.damagedQty }}
        </div>
      </div>

      <!-- Add Button -->
      <div class="col-md-3">
        <button class="btn button-default mt-4 w-100"
                @click="addItem">
          Add
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="col-sm-12 mt-3" v-if="items.length > 0">
      <div class="card">
        <div class="card-block row">
          <div class="col-sm-12">
            <table class="table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Normal Qty</th>
                  <th>Damaged Qty</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                  <td>{{ getItemName(item.item_id) }}</td>
                  <td>{{ item.normal_qty }}</td>
                  <td>{{ item.damaged_qty }}</td>
                  <td>
                    <i class="fa fa-edit text-primary mr-3"
                       style="cursor: pointer;"
                       @click="openEditModal(index)"></i>
                    <i class="fa fa-trash text-danger"
                       style="cursor: pointer;"
                       @click="removeItem(index)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div class="modal-footer">
      <button class="btn btn-success"
              :disabled="items.length === 0 || loading"
              @click="saveInitialStock">
        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
        <span v-else>Save</span>
      </button>
    </div>

    <!-- Edit Modal -->
    <div v-if="showEditModal" class="modal-backdrop-custom d-flex align-items-center justify-content-center">
      <div class="bg-white p-4" style="width: 100%; max-width: 500px; border-radius: 8px; box-shadow: 0 10px 25px rgba(0,0,0,0.2);">
        
        <h5 class="m-0 font-weight-bold mb-4" style="font-size: 1.25rem;">Edit Item Quantities</h5>
        
        <div class="form-group" style="margin-bottom: 1rem; width: 100%;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Item</label>
          <input type="text" class="form-control" style="width: 100%; display: block;" :value="getItemName(editItemData.item_id)" disabled>
        </div>

        <div class="form-group" style="margin-bottom: 1rem; width: 100%;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Normal Qty</label>
          <input type="number" class="form-control" style="width: 100%; display: block;" v-model="editItemData.normal_qty" min="0">
          <div v-if="editErrors.normalQty" class="text-danger mt-1" style="font-size: 0.85em;">{{ editErrors.normalQty }}</div>
        </div>

        <div class="form-group" style="margin-bottom: 1.5rem; width: 100%;">
          <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Damaged Qty</label>
          <input type="number" class="form-control" style="width: 100%; display: block;" v-model="editItemData.damaged_qty" min="0">
          <div v-if="editErrors.damagedQty" class="text-danger mt-1" style="font-size: 0.85em;">{{ editErrors.damagedQty }}</div>
        </div>

        <div style="display: flex; justify-content: flex-end; width: 100%; margin-top: 2rem; border-top: 1px solid #eee; padding-top: 1rem; gap: 10px;">
          <button type="button" class="btn btn-secondary" @click="closeEditModal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="updateItem">Update</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { fetchItemNameList, saveInitialStock } from '@/services/dataService';
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      selectedItem: "",
      normalQty: "",
      damagedQty: "",
      items: [],
      allItems: [],
      localToken: "",
      errors: {
        item: "",
        quantity: ""
      },
      loading: false,

      showEditModal: false,
      editItemIndex: null,
      editItemData: {
        item_id: "",
        normal_qty: "",
        damaged_qty: ""
      },
      editErrors: {
        normalQty: "",
        damagedQty: ""
      }
    };
  },

  computed: {
    availableItems() {
      return this.allItems.filter(
        item => !this.items.some(selected => String(selected.item_id) === String(item.id))
      );
    }
  },

  methods: {

    async fetchAuthToken() {
      this.localToken = localStorage.getItem('token_set');
    },

    async loadItems() {
      await this.fetchAuthToken();
      const companyId = localStorage.getItem('company_id');

      const response = await fetchItemNameList(companyId, 1, this.localToken);
      if (response.data.status === 'success') {
        this.allItems = response.data.data;
      }
    },

    addItem() {
      this.errors = { item: "", quantity: "" };

      if (!this.selectedItem) {
        this.errors.item = "Please select an item.";
        return;
      }

      if (this.normalQty === "" || this.normalQty < 0) {
        this.errors.normalQty = "Enter valid normal qty.";
        return;
      }

      if (this.damagedQty === "" || this.damagedQty < 0) {
        this.errors.damagedQty = "Enter valid damaged qty.";
        return;
      }

      const exists = this.items.find(i => i.item_id === this.selectedItem);
      if (exists) {
        this.errors.item = "Item already added.";
        return;
      }

      this.items.push({
        item_id: this.selectedItem,
        normal_qty: this.normalQty,
        damaged_qty: this.damagedQty
      });

      this.selectedItem = "";
      this.normalQty = "";
      this.damagedQty = "";
    },

    removeItem(index) {
      this.items.splice(index, 1);
    },

    openEditModal(index) {
      this.editItemIndex = index;
      const item = this.items[index];
      this.editItemData = {
        item_id: item.item_id,
        normal_qty: item.normal_qty,
        damaged_qty: item.damaged_qty
      };
      this.editErrors = { normalQty: "", damagedQty: "" };
      this.showEditModal = true;
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editItemIndex = null;
      this.editItemData = { item_id: "", normal_qty: "", damaged_qty: "" };
      this.editErrors = { normalQty: "", damagedQty: "" };
    },

    updateItem() {
      this.editErrors = { normalQty: "", damagedQty: "" };

      if (this.editItemData.normal_qty === "" || this.editItemData.normal_qty < 0) {
        this.editErrors.normalQty = "Enter valid normal qty.";
        return;
      }

      if (this.editItemData.damaged_qty === "" || this.editItemData.damaged_qty < 0) {
        this.editErrors.damagedQty = "Enter valid damaged qty.";
        return;
      }

      if (this.editItemIndex !== null) {
        this.items[this.editItemIndex].normal_qty = this.editItemData.normal_qty;
        this.items[this.editItemIndex].damaged_qty = this.editItemData.damaged_qty;
      }

      this.closeEditModal();
    },

    getItemName(id) {
      const item = this.allItems.find(i => i.id === id);
      return item ? item.item_name : "";
    },

    async saveInitialStock() {
      this.loading = true;
      const toast = useToast();
      await this.fetchAuthToken();

      const profileId = localStorage.getItem('profile_id');
      const profile_name = localStorage.getItem('profile_name');

      const payload = {
        created_by: profileId,
        profile_name: profile_name,
        details: this.items.map(i => ({
          item_id: String(i.item_id),
          normal_qty: Number(i.normal_qty).toFixed(2),
          damaged_qty: Number(i.damaged_qty).toFixed(2)
        }))
      };
      console.log("payload", payload);

      try {
        const response = await saveInitialStock(payload, this.localToken);

        toast(response.data.message, {
          type: response.data.status === 'success' ? 'success' : 'error'
        });

        if (response.data.status === 'success') {
          this.items = [];
        }

      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message, {
              position: "top-right",
              timeout: null,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              hideProgressBar: false,
            });
        } else {
          toast("Error saving initial stock", { type: "error" });
        }
      } finally {
        this.loading = false;
      }
    }
  },

  mounted() {
    this.loadItems();
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/pages/stockAllocation/stock-allocation-form';

  .modal-backdrop-custom {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999 !important;
  }
</style>